module.exports = __webpack_public_path__ + "static/media/domestic-bg.6cc9e2d7.jpg";